import React from 'react';
import { NumberInput, ReferenceInput, SelectInput } from 'react-admin';
import { RowForm } from '@react-admin/ra-editable-datagrid';

const WeeklyBillableForm = (props) => {
    return (
        <RowForm {...props}>
            <NumberInput source="value" label="Target Hours" />
            <NumberInput source="year" />
            <ReferenceInput
                label="Supervision Role"
                source="supervision_role"
                reference="users/supervision-role"
            >
                <SelectInput style={{ minWidth: 200 }} optionText="name" />
            </ReferenceInput>
        </RowForm>
    );
};

export default WeeklyBillableForm;
